<template>
  <div class="px-5 mt-8">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-card flat class="mb-3">
            <div class="px-6 py-4">
              <div class="d-flex align-center justify-space-between w-100">
                <div>
                  <h1 class="fs-18 font-weight-bold mb-1">Buat BPB</h1>
                  <p class="fs-14 text--secondary mb-0">
                    Buat BPB dari orderan
                  </p>
                </div>
                <!-- <div class="d-flex align-center">
                  <v-btn
                    color="primary"
                    elevation="0"
                    small
                    @click="toFetch()"
                    :loading="process.load"
                    class="text-capitalize"
                  >
                    <v-icon left>mdi-refresh</v-icon>
                    Refresh
                  </v-btn>
                </div> -->
              </div>
            </div>
          </v-card>
  
          <v-card elevation="0" class="pa-3" style="border-radius: 6px;">
            <v-card-title class="fs-14 font_weight_600 pa-3 mb-2 pa-0">
              <!-- <v-icon left color="primary" class="mr-2">mdi-plus-box</v-icon> -->
              Pilih Order
            </v-card-title>
            <v-divider class="mb-2"></v-divider>

            <v-row>
              <v-col cols="12" md="12">
                <v-card flat style="background: transparent;" class="pa-0">
                  <v-card-text class="py-0 px-2">
                    <ValidationObserver ref="form">
                      <v-form>
                        <v-row>
                          <v-col cols="12" md="12" class="pt-0">
                            <ValidationProvider name="No Order" rules="required" v-slot="{ errors }">
                              <div class="fs-15 label-input mb-1">No Order</div>
                              <v-autocomplete
                                filled
                                rounded
                                dense
                                solo
                                color="#718EBF"
                                placeholder="Pilih No Order"
                                v-on:change="changeOrder()"
                                :items="order"
                                item-value="id"
                                item-text="number"
                                :item-color="set_color"
                                v-model="form.order_id"
                                :error-messages="errors"
                                prepend-inner-icon="mdi-format-list-bulleted"
                                required
                                style="border-radius: 10px;"
                              />
                            </ValidationProvider>
                          </v-col>
                        </v-row>

                        <div v-if="Object.keys(order_json).length > 0">
                          <v-card flat style="border-radius: 6px; border: 1px solid #E7E7E7; background: #fff;" class="mb-8">
                            <v-card-title class="fs-14 font_weight_600 pa-3 input-label mb-0">
                              <!-- <v-icon left color="primary" class="mr-2">mdi-information-outline</v-icon> -->
                              Detail Order
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                              <v-row>
                                <v-col cols="12" md="7">
                                  <table style="width: auto;" class="mb-2" v-if="!process.load && Object.keys(order_json).length > 0">
                                    <tr>
                                      <td class="fs-12">Nama Toko</td>
                                      <td style="width: 40px" class="fs-12 text-center pb-2">: </td>
                                      <td class="text-left font-weight-bold fs-12">{{ order_json.store_name }}</td>
                                    </tr>
                                    <tr>
                                      <td class="fs-12" style="width: 100px;">Nama Pemilik</td>
                                      <td style="width: 40px" class="fs-12 text-center pb-2">: </td>
                                      <td class="text-left font-weight-bold fs-12">
                                        <a target="_blank" :href="`/customer/data/detail/${order_json.customer_id}`">
                                          {{ order_json.customer_name }}
                                        </a>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td class="fs-12">Alamat Detail</td>
                                      <td style="width: 40px" class="fs-12 text-center pb-2">: </td>
                                      <td class="text-left font-weight-bold fs-12">{{ order_json.shipping_address }}</td>
                                    </tr>
                                    <tr>
                                      <td class="fs-12">Alamat</td>
                                      <td style="width: 40px" class="fs-12 text-center pb-2">: </td>
                                      <td class="text-left font-weight-bold fs-12">{{ order_json.shipping_city }}, {{ order_json.shipping_province }}, {{ order_json.shipping_subdistrict }}, {{ order_json.shipping_village }}</td>
                                    </tr>
                                  </table>
                                </v-col>
                                <v-col cols="12" md="5">
                                  <table style="width: auto;" class="mb-2" v-if="!process.load && Object.keys(order_json).length > 0">
                                    <tr>
                                      <td class="fs-12">No. Order</td>
                                      <td style="width: 40px" class="fs-12 text-center pb-2">: </td>
                                      <td class="text-left font-weight-bold fs-12">{{ order_json.number }}</td>
                                    </tr>
                                    <tr>
                                      <td class="fs-12">Tanggal Order</td>
                                      <td style="width: 40px" class="fs-12 text-center pb-2">: </td>
                                      <td class="text-left font-weight-bold fs-12">{{ order_json.input_datetime | datetime }}</td>
                                    </tr>
                                    <tr>
                                      <td class="fs-12">Nama Sales</td>
                                      <td style="width: 40px" class="fs-12 text-center pb-2">: </td>
                                      <td class="text-left font-weight-bold fs-12">{{ order_json.sales_name }}</td>
                                    </tr>
                                  </table>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>

                          <v-card flat style="border-radius: 6px; border: 1px solid #E7E7E7; background: #fff;" class="mt-2 mb-3">
                            <v-card-title class="fs-14 font_weight_600 pa-3 input-label mb-0">
                              <!-- <v-icon left color="primary" class="mr-2">mdi-truck-delivery-outline</v-icon> -->
                              Detail Produk
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                              <v-row align="center">
                                <v-col cols="12" md="6">
                                  <ValidationProvider name="Jumlah Pengiriman" rules="required" v-slot="{ errors }">
                                    <v-autocomplete
                                      filled
                                      rounded
                                      dense
                                      solo
                                      color="#718EBF"
                                      placeholder="Jumlah Pengiriman"
                                      v-on:change="changeJumlah()"
                                      :items="[1,2,3,4,5,6,7,8,9]"
                                      item-value="id"
                                      item-text="number"
                                      :item-color="set_color"
                                      v-model="form.jumlah_bpb"
                                      :error-messages="errors"
                                      prepend-inner-icon="mdi-counter"
                                      required
                                      style="border-radius: 10px;"
                                    />
                                  </ValidationProvider>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>

                          <v-card flat style="border-radius: 6px; border: 1px solid #E7E7E7;" class="pb-7 mb-5" v-for="(items, indexs) in form.varian_arr" :key="indexs">
                            <v-card-title class="fs-14 font_weight_600 pa-3 input-label mb-0">
                              <!-- <v-icon left color="primary" class="mr-2">mdi-package-variant-closed</v-icon> -->
                              
                              <div class="d-flex align-center" style="width: 100%;">
                                <div>
                                  BPB Ke-{{ items.bpb_id }}
                                </div>
                                <div class="ml-auto">
                                  <v-btn
                                    color="primary"
                                    elevation="0"
                                    small
                                    @click="toFetch()"
                                    :loading="process.load"
                                    class="text-capitalize"
                                  >
                                    <v-icon left>mdi-refresh</v-icon>
                                    Refresh
                                  </v-btn>
                                </div>
                              </div>
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                              <table style="border-radius: 10px; width: 100%; border: thin solid #E6EFF5;" class="table mb-4 black--text">
                                 <thead>
                                   <tr>
                                     <th class="py-2 px-3" style="width: 25%;">
                                       <div class="fs-15">
                                         Nama Produk
                                       </div>
                                     </th>
                                     <th class="py-2 px-3" style="width: 20%;">
                                       <div class="fs-15">
                                         Kode SKU
                                       </div>
                                     </th>
                                     <th class="py-2 px-3" style="width: 10%;">
                                       <div class="fs-15">
                                         Total Qty
                                       </div>
                                     </th>
                                     <th class="py-2 px-3" style="width: 10%;">
                                       <div class="fs-15">
                                         Sisa Qty
                                       </div>
                                     </th>
                                     <th class="py-2 px-3" style="width: 30%;">
                                       <div class="fs-15">
                                         Qty yang akan dikirim
                                       </div>
                                     </th> 
                                     <th class="py-2 px-3" style="width: 5%;">
                                       <div class="fs-15">
                                         Hapus
                                       </div>
                                     </th> 
                                   </tr>
                                 </thead>
                                 <tbody>
                                   <tr v-for="(item, index) in items.varian_arr" :key="index+items.bpb_id" v-if="!item.is_deleted">
                                     <td class="py-2 px-3">
                                       <div class="font-weight-bold fs-14">
                                         {{ item.varian_name }}
                                       </div>
                                     </td>
                                     <td class="py-2 px-3">
                                       <div class="fs-12 text--secondary">
                                         {{ item.varian_sku }}
                                       </div>
                                     </td>
                                     <td class="py-2 px-3">
                                       <div v-if="item.qty_pcs_approve_warehouse*1 > 0" class="mb-1">
                                         <v-chip x-small color="primary" outlined>
                                           {{ item.qty_pcs_approve_warehouse }} Pcs
                                         </v-chip>
                                       </div>
                                       <div v-if="item.qty_lusin_approve_warehouse*1 > 0" class="mb-1">
                                         <v-chip x-small color="success" outlined>
                                           {{ item.qty_lusin_approve_warehouse }} Lusin
                                         </v-chip>
                                       </div>
                                       <div v-if="item.qty_dus_approve_warehouse*1 > 0">
                                         <v-chip small color="warning" class="text-capitalize font-weight-bold" style="width: 100%;">
                                           {{ item.qty_dus_approve_warehouse }} Dus
                                         </v-chip>
                                       </div>
                                     </td>
                                     <td class="py-2 px-3">
                                       <div v-if="item.qty_dus_approve_warehouse*1 > 0">
                                         <v-chip 
                                           small 
                                           :color="sisaQtyPerVarian[item.varian_id] < 0 ? 'error' : 'info'"
                                           class="text-capitalize font-weight-bold"
                                           style="width: 100%;"
                                         >
                                           {{ sisaQtyPerVarian[item.varian_id] }} Dus
                                         </v-chip>
                                       </div>
                                       <div v-else class="text--secondary fs-12">
                                         -
                                       </div>
                                     </td>
                                     <td class="py-2 px-3">
                                       <div class="d-flex flex-column">
                                         <div v-if="item.qty_pcs_approve_warehouse*1 > 0" class="mb-2">
                                           <ValidationProvider
                                             :name="`Qty Pcs ${item.varian_name}`"
                                             :rules="`required|max_value:${item.qty_pcs_approve_warehouse}|min_value:1`" 
                                             v-slot="{ errors }"
                                           >
                                             <v-currency-field
                                               filled
                                               rounded
                                               dense
                                               solo
                                               color="#718EBF"
                                               placeholder="0"
                                               suffix="pcs"
                                               v-model="item.qty_pcs_approve"
                                               :error-messages="errors"
                                               required
                                               style="border-radius: 8px; max-width: 120px;"
                                             />
                                           </ValidationProvider>
                                         </div>
                                         <div v-if="item.qty_lusin_approve_warehouse*1 > 0" class="mb-2">
                                           <ValidationProvider
                                             :name="`Qty Lusin ${item.varian_name}`"
                                             :rules="`required|max_value:${item.qty_lusin_approve_warehouse}|min_value:1`" 
                                             v-slot="{ errors }"
                                           >
                                             <v-currency-field
                                               filled
                                               rounded
                                               dense
                                               solo
                                               color="#718EBF"
                                               placeholder="0"
                                               suffix="lusin"
                                               v-model="item.qty_lusin_approve"
                                               :error-messages="errors"
                                               required
                                               style="border-radius: 8px; max-width: 120px;"
                                             />
                                           </ValidationProvider>
                                         </div>
                                         <div v-if="item.qty_dus_approve_warehouse*1 > 0">
                                           <ValidationProvider
                                             :name="`Qty Dus ${item.varian_name} ke-${index+1} dari BPB ke-${items.bpb_id}`" 
                                             :rules="`required|max_value:${item.qty_dus_approve_warehouse}|min_value:1`" 
                                             v-slot="{ errors }"
                                           >
                                             <v-currency-field
                                               filled
                                               rounded
                                               dense
                                               solo
                                               color="#718EBF"
                                               placeholder="0"
                                               suffix="dus"
                                               v-model="item.qty_dus_approve"
                                               @input="debouncedHitung"
                                               :error-messages="errors"
                                               required
                                               style="border-radius: 8px; max-width: 100%;"
                                             />
                                             <!-- <v-alert
                                               v-if="qtyErrors[item.varian_id]"
                                               type="error"
                                               dense
                                               class="mt-2"
                                             >
                                               {{ qtyErrors[item.varian_id] }}
                                             </v-alert> -->
                                           </ValidationProvider>
                                         </div>
                                       </div>
                                     </td>
                                     <td class="py-2 px-3">
                                       <v-btn icon small color="red" @click="hapusVarian(indexs, index)">
                                         <v-icon>mdi-delete</v-icon>
                                       </v-btn>
                                     </td>
                                   </tr>
                                 </tbody>
                               </table>

                               <!-- Error Alert untuk BPB ini -->
                               <v-alert
                                 v-if="getBpbErrors(items.varian_arr).length > 0"
                                 type="error"
                                 dense
                                 class="mt-3 mx-3"
                               >
                                 <div class="d-flex align-center">
                                   <v-icon left>mdi-alert-circle</v-icon>
                                   <span class="font-weight-bold">Terdapat {{ getBpbErrors(items.varian_arr).length }} error:</span>
                                 </div>
                                 <div class="mt-2">
                                   <div v-for="error in getBpbErrors(items.varian_arr)" :key="error" class="ml-4">
                                     • {{ error }}
                                   </div>
                                 </div>
                               </v-alert>

                            </v-card-text>
                            
                          </v-card>
                        </div>
                      </v-form>
                    </ValidationObserver>

                    <v-alert v-if="message.error.length > 0" type="error" class="text-center my-4 d-flex align-center justify-center" border="left" colored-border>
                      <v-icon size="18" color="red" class="mr-2">mdi-alert-circle-outline</v-icon>
                      <span>{{ message.error }}</span>
                    </v-alert>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-divider class="my-6"></v-divider>

            <v-row justify="end" class="pa-4 pt-0 pr-1">
              <v-col cols="12" md="12" class="d-flex align-center justify-end py-0">
                <v-alert
                  type="info"
                  dense
                  class="mt-3 mx-3"
                  v-if="form.varian_arr.some(item => item.varian_arr.some(variant => variant.qty_dus_approve === 0 && !variant.is_deleted))"
                >
                  <div class="d-flex align-center">
                    <span class="font-weight-bold">
                      Data tidak dapat disimpan jika ada quantity yang 0, jika memang quantity 0, silahkan hapus data tersebut
                    </span>
                  </div>
                </v-alert>
              </v-col>
              <v-col cols="12" md="12" class="d-flex align-center justify-end py-0">
                <v-btn @click="handleSubmit()" :loading="process.form" :disabled="process.form || isSubmitting" width="150" height="45" elevation="0" color="#1814F3" class="fs-16 white--text text-capitalize border-radius mr-2" style="font-weight: 600;">
                  <!-- <v-icon left>mdi-content-save</v-icon> -->
                  {{ (process.form || isSubmitting) ? 'Menyimpan...' : 'Simpan' }}
                </v-btn>
                <v-btn to="/delivery/bpb" :disabled="process.form" color="red" elevation="0" width="120" height="45" class="body-2 white--text text-capitalize d-flex align-center ml-2 border-radius" style="font-weight: 600;">
                  <!-- <v-icon left>mdi-close-circle-outline</v-icon> -->
                  Batal
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: {
          
        },
        category: [
          {
            title: 'Parsial',
            id: 'Parsial'
          },
          {
            title: 'Full',
            id: 'Full'
          }
        ],
        modal: false,
        menu2: false,

        dialog: {
          customer: false,
          fullscreen: false
        },
        bukti: 'gambar',
        gambar_url: '',
        pdf_url: '',
        category: ['Gambar', 'Pdf'],
        pembelian: [],
        product_id: '',
        selected: [],
        headers: [],
        list: [],
        supplier: [],
        form: {
          date: '',
          driver_id: '',
          note: '',
          vehicle_id: '',
          jumlah_bpb: '',
          order_id: '',
          // order_arr: [],
          varian_arr: [],
          // category: '',
          // image_url: '',
          // pdf_url: ''
        },
        order_json: [],
        vehicle: [],
        driver: [],
        order: [],
        headers_data: [],
        supervisor: [],
        branch: [],
        varian_arr: [],

        sisa_qty: 0,

        mobilephone: {
          name: '',
          id: ''
        },

        master_varian: [],

        lastIndex: 1,

        upload: {
          pdf_url: null,
          image_url: null
        },

        process: {
          form: false,

          pdf_url: false,

          image_url: false,

          load: false
        },
        isSubmitting: false,
        
        message: {
          success: '',
          error: ''
        },
        qtyValidationErrors: {},
        qtyErrors: {}, // Menyimpan error per varian_id
        sisaQtyPerVarian: {} // Menyimpan sisa qty per varian
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue'),
      uploaddocument: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/document.vue')
    },
    watch: {
      'upload.pdf_url': {
        handler: function () {
          if (this.upload.pdf_url) {
            this.process.pdf_url = this.upload.pdf_url.process

            if (!this.process.pdf_url) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.pdf_url = this.upload.pdf_url.fileuri

              // this.save_image()
            }
          }
        },
        deep: true
      },

      'upload.image_url': {
        handler: function () {
          if (this.upload.image_url) {
            this.process.image_url = this.upload.image_url.process

            if (!this.process.image_url) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.gambar_url = this.upload.image_url.fileuri

              // this.save_image()
            }
          }
        },
        deep: true
      },
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },
      configHeaders () {
          return this.headers_data.filter(header => !header.hide)  
        },
      isFormValid() {
        // Check if form has required data
        if (!this.form.order_id || !this.form.jumlah_bpb || this.form.varian_arr.length === 0) {
          return false;
        }
        
        // Check if all BPB have at least one variant
        for (let bpb of this.form.varian_arr) {
          if (!bpb.varian_arr || bpb.varian_arr.length === 0) {
            return false;
          }
          
          // Check if at least one variant has quantity > 0
          let hasValidQty = false;
          for (let variant of bpb.varian_arr) {
            if (!variant.is_deleted) {
              // Check if variant has any quantity > 0
              const qtyPcs = Number(variant.qty_pcs_approve || 0);
              const qtyLusin = Number(variant.qty_lusin_approve || 0);
              const qtyDus = Number(variant.qty_dus_approve || 0);
              
              if (qtyPcs > 0 || qtyLusin > 0 || qtyDus > 0) {
                hasValidQty = true;
                break;
              }
            }
          }
          
          if (!hasValidQty) {
            return false;
          }
        }
        
        return true;
      }
    },
    mounted () {
      this.fetchVehicle()
      this.fetchOrder()
      this.fetchDriver()
    },
    created() {
      this.debouncedHitung = this.debounce(this.hitungValidasiQtyDus, 200);
    },
    methods: {
      hapusVarian(indexs, index) {
        // Splice form.varian_arr but keep master_varian unchanged
        this.form.varian_arr[indexs].varian_arr.splice(index, 1)
        
        console.log(this.master_varian)
        this.hitungValidasiQtyDus()
      },

      getBpbErrors(varianArr) {
        const errors = []
        varianArr.forEach(item => {
          if (this.qtyErrors[item.varian_id]) {
            errors.push(this.qtyErrors[item.varian_id])
          }
        })
        return errors
      },

      getTotalQty(varianArr, type) {
        let total = 0
        varianArr.forEach(item => {
          switch(type) {
            case 'pcs':
              total += Number(item.qty_pcs_approve || 0)
              break
            case 'lusin':
              total += Number(item.qty_lusin_approve || 0)
              break
            case 'dus':
              total += Number(item.qty_dus_approve || 0)
              break
          }
        })
        return total
      },

      debounce(fn, delay) {
        let timeout;
        return function (...args) {
          clearTimeout(timeout);
          timeout = setTimeout(() => fn.apply(this, args), delay);
        };
      },

      toFetch() {
        // Restore from master_varian but preserve existing qty data
        const restoredData = JSON.parse(JSON.stringify(this.master_varian))
        
        // Preserve existing qty data from form.varian_arr using varian_id
        this.form.varian_arr.forEach((bpbItem, bpbIndex) => {
          if (restoredData[bpbIndex]) {
            // Create a map of existing qty data by varian_id
            const existingQtyMap = {}
            bpbItem.varian_arr.forEach((varianItem) => {
              existingQtyMap[varianItem.varian_id] = {
                qty_pcs_approve: varianItem.qty_pcs_approve || 0,
                qty_lusin_approve: varianItem.qty_lusin_approve || 0,
                qty_dus_approve: varianItem.qty_dus_approve || 0
              }
            })
            
            // Apply existing qty data to restored data using varian_id
            restoredData[bpbIndex].varian_arr.forEach((varianItem) => {
              if (existingQtyMap[varianItem.varian_id]) {
                varianItem.qty_pcs_approve = existingQtyMap[varianItem.varian_id].qty_pcs_approve
                varianItem.qty_lusin_approve = existingQtyMap[varianItem.varian_id].qty_lusin_approve
                varianItem.qty_dus_approve = existingQtyMap[varianItem.varian_id].qty_dus_approve
              }
            })
          }
        })
        
        this.form.varian_arr = restoredData
      },

      hitungValidasiQtyDus() {
        const varianMap = {};
        const errors = {};

        // Hitung total approve & stok
        this.form.varian_arr.forEach(item => {
          item.varian_arr.forEach(variant => {
            const id = variant.varian_id;

            if (variant.is_deleted) {
              return
            }

            if (!varianMap[id]) {
              varianMap[id] = {
                totalApprove: 0,
                warehouseQty: variant.qty_dus_approve_warehouse,
                name: variant.varian_name
              };
            }

            varianMap[id].totalApprove += Number(variant.qty_dus_approve || 0);
          });
        });


        // Validasi dan hitung sisa
        Object.keys(varianMap).forEach(id => {
          const { totalApprove, warehouseQty, name } = varianMap[id];
          const sisa = warehouseQty - totalApprove;

          this.$set(this.sisaQtyPerVarian, id, sisa);

          if (totalApprove > warehouseQty) {
            errors[id] = `Total qty dus untuk varian "${name}" melebihi stok gudang (${totalApprove}/${warehouseQty})`;
          }
        });

        this.qtyErrors = errors;

        return Object.keys(errors).length === 0;
      },

      async handleSubmit() {
        // Prevent double submission - immediate protection
        if (this.process.form || this.isSubmitting) {
          return;
        }

        // Set flag immediately to prevent any race condition
        this.isSubmitting = true;

        // Validate form first
        const formValid = await this.$refs.form.validate();
        if (!formValid) {
          this.isSubmitting = false;
          // Auto focus on first error field
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            if (errors.length > 0) {
              this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              })
            }
          }, 10)
          return;
        }

        // Validate quantity
        const valid = this.hitungValidasiQtyDus();
        if (!valid) {
          this.isSubmitting = false;
          this.$toast.error('Terdapat kesalahan pada input quantity');
          return;
        }

        // lanjutkan submit
        this.save();
      },
      async fetchOrder () {
        this.process.load = true

        let params = {
          limit: 1000000,
          status: 'persiapan',
          is_bpb: '0'
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/order/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.pembelian = res.results.data
            this.order = res.results.data
            
          }
          this.process.load = false
        })
      },
      async fetchVehicle () {
        this.process.load = true

        let params = {
          limit: 10000000,
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/vehicle/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.vehicle = res.results.data
            
          }
          this.process.load = false
        })
      },
      async fetchDriver () {
        this.process.load = true

        let params = {
          limit: 10000000,
          'category_user_id[eq]': '11',
          is_active: 'Aktif',
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/user/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.driver = res.results.data
            
          }
          this.process.load = false
        })
      },
      addPcs(i, l){
        this.form.varian_arr[i].varian_arr[l].qty_pcs_approve
      },

      changeOrder() {
        this.order_json = this.order.find(x => x.id === this.form.order_id)
        this.form.jumlah_bpb = ''
        this.form.varian_arr = []
      },

      changeJumlah() {
        let data = []
        this.form.varian_arr = []
        this.master_varian = []
        for (let i = 0; i < this.form.jumlah_bpb; i++) {
          this.fetchDetailOrder(this.form.order_id, i+1)
        }
      },

      async fetchDetailOrder (id, bpb_id) {
        let params = {
          id: id
        }

        await get('admin/order/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            // let data = []

            
            this.varian_arr = []
            res.results.data.detail.map((item) => {
             
              this.varian_arr.push({
                varian_id: item.detail_varian_id,
                varian_name: item.detail_varian_name,
                varian_sku: item.detail_varian_sku,
                qty_pcs_approve: 0,
                qty_lusin_approve: 0,
                qty_dus_approve: 0,
                qty_pcs_approve_warehouse: item.detail_qty_pcs_approved === undefined ? 0 : item.detail_qty_pcs_approved*1,
                qty_lusin_approve_warehouse: item.detail_qty_lusin_approved === undefined ? 0 : item.detail_qty_lusin_approved*1,
                qty_dus_approve_warehouse: item.detail_qty_dus_approved === undefined ? 0 : item.detail_qty_dus_approved*1,
                is_deleted: false
              })
            })

            this.form.varian_arr.push(
              {
                bpb_id: bpb_id,
                varian_arr: this.varian_arr
              }
            )

            this.master_varian.push(
              {
                bpb_id: bpb_id,
                varian_arr: JSON.parse(JSON.stringify(this.varian_arr))
              }
            )

            this.hitungValidasiQtyDus();

          }
        })
      },

      async save () {
        this.message.error = ''

        let data = []

        this.form.varian_arr.forEach(item => {
          item.varian_arr.forEach(variant => {
            if (!variant.is_deleted) {
              data.push(variant)
            }
          })
        })
        console.log(data)
        let form = {
          order_id: this.form.order_id,
          jumlah_bpb: this.form.jumlah_bpb,
          // note: this.form.note,
          // vehicle_id: this.form.vehicle_id,
          // order_arr: JSON.stringify(this.order_json.map(item => {
          //   return {
          //     order_id: item.order_id,
                varian_arr: JSON.stringify(this.form.varian_arr.map(item => 

                  item.varian_arr
                  
                
                )
                )
              // }
            // )),
        }
        console.log(form)
        this.process.form = true

        // SAVE TO REST API
        await post(`admin/bpb/add`, {
          data: form
        })
        .then((response) => {
          let res = response.data

          this.process.form = false
          this.isSubmitting = false

          if (res.status === 200) {

            this.$router.push({ path: '/delivery/bpb' })

          } else {
            this.message.error = res.message
          }
        })
        .catch((error) => {
          this.process.form = false
          this.isSubmitting = false
          this.message.error = 'Terjadi kesalahan saat menyimpan data'
        })
      }
    }
  }
</script>

<style >
table {
  border-collapse: collapse;
  width: 100%;
}

.table th {
  background-color: #f5f5f5;
  border-bottom: 2px solid #E6EFF5;
  font-weight: 600;
}

.table td {
  border-bottom: 1px solid #E6EFF5;
  vertical-align: top;
}

.table tr:hover {
  background-color: #f9f9f9;
}

/* tr {
  border-bottom: 1px solid #ddd;
} */
</style>